import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=574c818a&scoped=true"
import script from "./UserLayout.vue?vue&type=script&lang=js"
export * from "./UserLayout.vue?vue&type=script&lang=js"
import style0 from "./UserLayout.vue?vue&type=style&index=0&id=574c818a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574c818a",
  null
  
)

export default component.exports